import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

export const Row = styled.div({
  display: "flex",
  flexDirection: "column",
  marginTop: "40px",
  "&:empty": { display: "none" },
});

export const LiveArea = styled.div({
  backgroundColor: "#fff",
  padding: "8px 32px 40px",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "746px",
});

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InfoButton = styled.button`
  display: flex;
  margin-left: ${({ theme }) => defaultTheme.MARGIN.SM};
  background: none;
  color: inherit;
  border: none;
  font: inherit;
  cursor: pointer;
  &:active {
    opacity: 0.5;
  }
`;

export const Link = styled.a`
  color: ${({ theme }) => defaultTheme.COLORS.BLACK_GREY};

  &:visited {
    color: ${({ theme }) => defaultTheme.COLORS.BLACK_GREY};
  }
`;
